

import React, { useState, useRef, useEffect } from 'react';
import { FaUser } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import LogoutConfirmModal from '../modal/LogoutConfirmModal'
export default function Header() {
  const navigate = useNavigate();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showLogout, setShowLogout] = useState(false);
  const dropdownRef = useRef();
  const [hideHeader, setHideHeader] = useState(false);
  const storedUser = localStorage.getItem("user");
  const userData = storedUser ? JSON.parse(storedUser) : null;
  const role = userData?.user?.comp_code || null;
  const name = userData?.user?.name || "Guest";

  const handleLogout = () => {
    localStorage.removeItem("user");

    if (role === "operator") {
      navigate("/");
    } else {
      navigate("/login");
    }
  };

  useEffect(() => {
    const checkScreen = () => {
      if (
        role === "operator" &&
        window.innerWidth >= 500 &&
        window.innerWidth <= 860 &&
        window.innerHeight <= 600
      ) {
        setHideHeader(true);
      } else {
        setHideHeader(false);
      }
    };

    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, [role]);
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowLogout(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  if (hideHeader) return null;

  return (
    <div className="container-fluid bg-primary text-white py-2 header font_family headerTop">
      <div className="row align-items-center">
        <div className="col-md-1"></div>

        <div className="col-md-10 d-flex justify-content-between align-items-center">
          <h5 className="mb-0 fw-bold">Factory Floor Portal</h5>

          <div className="position-relative" ref={dropdownRef}>
            <div
              className="d-flex align-items-center gap-2 cursor-pointer"
              onClick={() => setShowLogout((prev) => !prev)}
              style={{ cursor: "pointer" }}
            >
              <FaUser />
              <span>{name}{role && ` (${role})`}</span>
            </div>

            {showLogout && (
              <div
                className="position-absolute bg-white text-dark border rounded shadow-sm p-2 mt-2"
                style={{ right: 0, zIndex: 1000 }}
              >
                <button
                  className="btn btn-sm btn-primary w-100"
                  onClick={() => {
                    if (role === "operator") {
                      setShowLogout(false);
                      setShowLogoutModal(true);
                    } else {
                      handleLogout();
                    }
                  }}
                >
                  Logout
                </button>

              </div>
            )}
          </div>
        </div>

        <div className="col-md-1"></div>
      </div>

      <LogoutConfirmModal
        show={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
        onConfirm={handleLogout}
      />
    </div>
  );
}
